import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
//import ConversationClass from '/chat/src/lib/Conversation';
import CustomizationModel from '/chat/src/redux/model/customization/model';
import SystemModel from '/chat/src/redux/model/system/model';
import {TicketModel} from '/chat/src/redux/model';
import CompanyModel from '/chat/src/redux/model/company/model';


class NewConversationButton extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        const text = this.props.language.get('NewConversation');
        return (
            <div className={style.NewConversationWrapper}>
                <div
                    className={style.NewConversationButton}
                    style={{backgroundColor: this.props.color}}
                    onClick={this.handleClick}>
                        <div className={style.NewConversationText}>
                        {text}
                        </div>
                </div>
            </div>
        );
    }

    handleClick() {
            this.props.dispatch(TicketModel.setCurrentRoom(''))
        if(this.props.isOffline || this.props.formsRequire){
            this.props.dispatch(SystemModel.setRoute('StartChatting'));
        }else{
            this.props.dispatch(SystemModel.setRoute('Chat'));
        }
    }
}

function mapStateToProps(state) {
    const language = CustomizationModel.getLanguage(state);
    const color = CustomizationModel.getColor(state);
    const isOffline = CompanyModel.isOffline(state);
    return { language, color, isOffline,
        formsRequire: CustomizationModel.getFormsRequire(state),
    };
}

export default connect(mapStateToProps)(NewConversationButton);



// WEBPACK FOOTER //
// ./routes/Conversations/NewConversationButton/index.js